import React, { useRef, useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const Layout = ({ children }) => {
  const location = useLocation();

  const getBackgroundClass = () => {
    if (location.pathname === '/') {
      return 'default-bg';
    }
    if (location.pathname.startsWith('/project-showcase/01')) {
      return '_1-bg';
    }
    if (location.pathname.startsWith('/project-showcase/02')) {
      return '_2-bg';
    }
    if (location.pathname.startsWith('/project-showcase/03')) {
      return '_3-bg';
    }
    if (location.pathname.startsWith('/project-showcase/04')) {
      return '_4-bg';
    }
    if (location.pathname === '/about') {
      return 'red-bg';
    }
    return 'default-bg';
  };

  // const getTextColorClass = () => {
  //   const projectNumber = location.pathname.match(/\/project-showcase\/(\d+)/);
  //   if (projectNumber) {
  //     const number = parseInt(projectNumber[1]);
  //     return number % 2 === 0 ? 'text-light' : 'text-dark';
  //   }
  //   return 'text-dark';
  // };

  const videoRef = useRef(null);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const videoEl = videoRef.current;
    if (videoEl) {
      videoEl.addEventListener('loadeddata', () => {
        setLoaded(true);
      });
    }
  }, []);

  return (
    <div className={`app-container ${getBackgroundClass()} text-light`}>
      {getBackgroundClass() === 'default-bg' ? (
        <video
          ref={videoRef}
          className={`bg-video ${loaded ? 'loaded' : ''}`}
          autoPlay
          loop
          muted
          playsInline
        >
          <source src='/assets/common/home-bg.mp4' type='video/mp4' />
        </video>
      ) : (
        <div class='hero'>
          <div class='overlay'></div>
        </div>
      )}
      {children}
    </div>
  );
};

export default Layout;
